export const useDefaultData = ({Helpers}) => {

    const {fecha_actual, getPreviousMonthDate, getNextMonthDate} = Helpers
    
    const defaultFormGlobal = {
        idagenda: 0,
        fecha_acutal: fecha_actual,
        fecha_inicio: getPreviousMonthDate(fecha_actual),
        fecha_final: getNextMonthDate(fecha_actual),      
    }
    
    const defaultDataModal = {
        open: false,
        titleModal: '',
        componentModal: '',
        dataRequest: {},
    }
    
    const defaultFormModal = {
        idagenda: 0,
        tipo_evento: '',
        color: '',
        fecha_evento: '',
        fecha_ren_seguro: '',
        fecha_ren_gps: '',
        seguro: '',
        gps: '',
        identificador: '',
        cliente: '',
        dias_atrasado: 0,
        telefono: '',
        correo: '',
        direccion: '',
        dpi: ''     
    }


  return Object.freeze({
      defaultFormGlobal,
      defaultFormModal,
      defaultDataModal,

  })
}